<template>
    <div class="full">
      <CoverFilterSummary v-model="filters"></CoverFilterSummary>
      <v-data-table  :headers="quotedHeaders" :pagination.sync="pagination"
         :rows-per-page-items="pagination.rowsPerPageItems"
         :loading="loading"
         :total-items="pagination.totalItems"
         :items="covers" class="elevation-1" >
         <template slot="headers" slot-scope="props">
              <tr>
               <template v-for="header in props.headers">
                  <th  v-if="isColumnVisible(header) && (extendedMode || columnsAlwaysShown.includes(header.value))" :key="$t(header.text)" :class="$t(header.text).toUpperCase() === 'Action'.toUpperCase()?'text-xs-center' :'text-xs-left'">
                     {{ $t(header.text) }}
                   </th>
               </template>
              </tr>
        </template>
        <template v-slot:items="props">
           <tr  @click="showCoverDetail(props.item.id, props.item.statusCode)" v-bind:class="selectedRow === props.item.id ?'selectedrow' : ''">
            <td class="text-xs-left"></td>
            <td class="text-xs-left">{{ props.item.seller.name }}<br/> <span class="smalltext greytext"> {{ props.item.seller.identifierType.toUpperCase() }} {{ props.item.seller.identifierValue }} </span></td>
            <td class="text-xs-left">{{ props.item.buyer.name }}<br/><span class="smalltext greytext">{{ props.item.buyer.identifierType.toUpperCase() }} {{ props.item.buyer.identifierValue }}</span> </td>
            <td class="text-xs-left">{{ $formatDate(props.item.issuedAt)  }}</td>
            <td v-if="extendedMode" class="text-xs-left">{{ $formatDate(props.item.dueAt) }} </td>
            <td v-if="extendedMode" class="text-xs-left">{{ props.item.amount}}</td>
            <td v-if="extendedMode && props.item.isRemaining" class="text-xs-left"><span class="twoline latedetails"><span v-bind:class="props.item.statusCode.toLowerCase()"><p class="centerText"> {{ $toTitleCase(props.item.status)}}</p> </span><span class="smalltext redtext" style="margin-top: 5px;">{{$t('Cover.ListCover.DAYS_REMAINING_DESC', { daysRemainingNumber: props.item.daysRemaining })}}</span></span> </td>
            <td v-if="extendedMode && !props.item.isRemaining" class="text-xs-left"><span v-bind:class="props.item.statusCode.toLowerCase()"><p class="centerText"> {{ $toTitleCase(props.item.status)}}</p> </span></td>
            <!-- The action column, only for User that can update cover -->
            <td v-if="$parent.isUserThatCanUpdateCovers && extendedMode" class="text-xs-center">
              <v-btn v-if="!loading" @click.stop="$parent.openUpdateCover(props.item.id)" color="primary">{{$t('Cover.ListCover.UPDATE_BTN')}}</v-btn>
            </td>
          </tr>
        </template>
        <template slot="no-data">
              <div v-if="loading" class="text-xs-center">
                    <v-progress-circular indeterminate  color="primary"></v-progress-circular>
              </div>
              <div v-else>
                  <p class="centerText"> {{$t('Cover.ListCover.NO_DATA_AVAILABLE_DESC')}} </p>
              </div>
        </template>
      </v-data-table>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import constants from '@/constants/index'
import transactorApi from '@/services/TransactorApi'
import CoverFilterSummary from '@/components/common/CoverFilterSummary.vue'
export default {
  components: { CoverFilterSummary },
  data () {
    return {
      selectedRow: '',
      columnsAlwaysShown: ['first', 'seller', 'buyer', 'issuedate']
    }
  },
  watch: {
    pagination: {
      async handler () {
        this.$store.dispatch('coverquoted/startLoadCovers')
        await this.searchCovers(this.filters.identifierValue, this.filters.identifierTypeCode, this.filters.identifierCountryCode, this.filters.coverId)
      }
    },
    filters: {
      async handler () {
        this.$store.dispatch('coverquoted/startLoadCovers')
        await this.searchCovers(this.filters.identifierValue, this.filters.identifierTypeCode, this.filters.identifierCountryCode, this.filters.coverId)
      }
    },
    deep: true
  },
  methods: {
    async showCoverDetail (coverid, coverStatus) {
      if (coverStatus.toLowerCase() === constants.CoverStatus.ASSESSING.toLowerCase().toLowerCase()) { return }
      this.selectedRow = coverid
      this.$parent.setHeightForSideInfo()
      this.$store.dispatch('cover/setExtendedMode', false)
      await this.$parent.showCoverInfoDetail(coverid, false, 'Quoted', false)
    },
    isColumnVisible (header) {
      return !header.isVisibleOnlyWhenUserCanUpdateCovers || (header.isVisibleOnlyWhenUserCanUpdateCovers && this.$parent.isUserThatCanUpdateCovers)
    },
    async searchCovers (identifierValue, identifierTypeCode, identifierCountryCode, coverId) {
      if (!!identifierValue && identifierValue.length > 0) {
        var transactorId = await transactorApi.fetchCompanyByExternalId(identifierCountryCode, identifierTypeCode, identifierValue)
        if (transactorId.length > 0) {
          this.$store.dispatch('coverquoted/getCoversQuoted', { coverStatusLabels: this.coverStatus, companyId: transactorId, coverId: coverId })
        } else {
          this.$store.dispatch('coverquoted/getEmptyCovers')
        }
      } else {
        this.$store.dispatch('coverquoted/getCoversQuoted', { coverStatusLabels: this.coverStatus, companyId: undefined, coverId: coverId })
      }
    }
  },
  computed: {
    pagination: {
      get: function () {
        return this.paginationData
      },
      set: function (value) {
        this.$store.dispatch('coverquoted/setPagination', value)
      }
    },
    items () {
      return this.covers
    },
    ...mapState('cover', ['extendedMode', 'quotedHeaders', 'coverStatus']),
    ...mapState('coverquoted', ['covers', 'paginationData', 'loading']),
    ...mapState('listcovertabs', ['filters'])
  }
}
</script>
